import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceSatisfiedIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M6.97436 10.6581C7.11781 10.2277 7.47637 9.55049 8.06927 8.98761C8.65367 8.4328 9.45211 8 10.5 8C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7C9.14792 7 8.11302 7.5672 7.38076 8.26239C6.65699 8.94951 6.21555 9.77226 6.02567 10.3419C5.93835 10.6039 6.07993 10.887 6.3419 10.9743C6.60387 11.0617 6.88703 10.9201 6.97436 10.6581Z"
        fill="#402A32"
      />
      <path
        d="M25.0257 10.6581C24.8822 10.2277 24.5237 9.55049 23.9308 8.98761C23.3464 8.4328 22.5479 8 21.5 8C21.2239 8 21 7.77614 21 7.5C21 7.22386 21.2239 7 21.5 7C22.8521 7 23.887 7.5672 24.6193 8.26239C25.343 8.94951 25.7845 9.77226 25.9744 10.3419C26.0617 10.6039 25.9201 10.887 25.6581 10.9743C25.3962 11.0617 25.113 10.9201 25.0257 10.6581Z"
        fill="#402A32"
      />
      <path
        d="M7.70711 16.2929C7.31658 15.9024 6.68342 15.9024 6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.81756 18.2318 8.14021 19 10 19C11.8598 19 13.1824 18.2318 13.7071 17.7071C14.0976 17.3166 14.0976 16.6834 13.7071 16.2929C13.3166 15.9024 12.6834 15.9024 12.2929 16.2929C12.1509 16.4349 11.3402 17 10 17C8.65979 17 7.8491 16.4349 7.70711 16.2929Z"
        fill="#402A32"
      />
      <path
        d="M19.7071 16.2929C19.3166 15.9024 18.6834 15.9024 18.2929 16.2929C17.9024 16.6834 17.9024 17.3166 18.2929 17.7071C18.8176 18.2318 20.1402 19 22 19C23.8598 19 25.1824 18.2318 25.7071 17.7071C26.0976 17.3166 26.0976 16.6834 25.7071 16.2929C25.3166 15.9024 24.6834 15.9024 24.2929 16.2929C24.1509 16.4349 23.3402 17 22 17C20.6598 17 19.8491 16.4349 19.7071 16.2929Z"
        fill="#402A32"
      />
      <path
        d="M11.8001 23.4C11.4687 22.9582 10.8419 22.8686 10.4001 23.2C9.95823 23.5314 9.86869 24.1582 10.2001 24.6C10.8907 25.5208 12.8883 27 16.0001 27C19.1118 27 21.1094 25.5208 21.8001 24.6C22.1314 24.1582 22.0419 23.5314 21.6001 23.2C21.1582 22.8686 20.5314 22.9582 20.2001 23.4C19.8907 23.8125 18.4883 25 16.0001 25C13.5118 25 12.1094 23.8125 11.8001 23.4Z"
        fill="#402A32"
      />
    </svg>
  );
};
